module.exports = __webpack_public_path__ + "static/img/bcBgm.2054c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bcBgm.png
// module id = to4z
// module chunks = 1